// extracted by mini-css-extract-plugin
module.exports = {"form__loaded":"single-field-form_form__loaded__99yRH","form__centered":"single-field-form_form__centered__JaK__","form":"single-field-form_form__U4AVx"};